import { Yubinbango } from '../lib/yubinbango';
import { ExhibitorModel, BadgeModel } from '../api';
import queryString from 'query-string';

export const updateFieldsByPostalCode = (code: string, setValue: (field: string, value:any, isValidate: boolean) => void) => {
  new Yubinbango(code, (x: any) => {
    if (x.region !== '') {
      setValue('prefecture', x.region, true);
    }
    if (x.locality !== '' || x.street !== '') {
      setValue('municipality', x.locality + x.street, true);
    }
  });
}

export const calcMaxBadgesCount = (boothsCount: number): number => {
  return boothsCount * 4 + 2
}

export const makeAccountMailMessage = (exhibitor: ExhibitorModel): string => {
  let url = process.env.REACT_APP_FRONT_URL
  if (exhibitor.exhibition === 'SPORTEC2023' || exhibitor.exhibition === 'CAFERES2023' || exhibitor.exhibition === 'ILOJ2023' || exhibitor.exhibition === 'WELLNESS2023') {
    if (exhibitor.exhibition === 'SPORTEC2023') {
      url = process.env.REACT_APP_SPORTEC_FRONT_URL
    }
    if (exhibitor.exhibition === 'CAFERES2023') {
      url = process.env.REACT_APP_CAFERES_FRONT_URL
    }
    if (exhibitor.exhibition === 'ILOJ2023') {
      url = process.env.REACT_APP_ILOJ_FRONT_URL
    }
    if (exhibitor.exhibition === 'WELLNESS2023') {
      url = process.env.REACT_APP_WELLNESS_FRONT_URL
    }
    return `本メールは下記のアドレス宛に送付されています。
${exhibitor.email}


${exhibitor.companyName || ''}
${exhibitor.familyName || ''}　${exhibitor.givenName || ''}　様

出展社の入場バッジ申請について、ご案内いたします。
TSO International（株）では、出展社バッジについても来場者バッジ同様
ご利用者の情報を登録し、ご自身で印刷・ご持参いただく必要がございます。
下記の申請用ページにて、情報登録を行ってください。

----------------------------------------------------------------------
■会社名： ${exhibitor.companyName || ''}
■部署： ${exhibitor.department || ''}
■担当者名: ${exhibitor.familyName || ''}　${exhibitor.givenName || ''}　様
■ID : ${exhibitor.accountId}
■パスワード: ${exhibitor.password}
＜出展社バッジ申請用サイトログインページ＞
${url}/#/explain
→ID・パスワードを入力して、ログインしてください。
----------------------------------------------------------------------

～申請から発行までの流れ～
1.上記の出展社バッジ申請用サイトにて、会場に来られるすべてのスタッフ分の登録を行ってください（枚数の制限はありません）。
2.申請したご利用者宛にメールにて通知が届きます。
3.ご利用者ご自身で出展社バッジを印刷してご持参の上、
各ホールの出入口付近に設置していますバッジホルダーからホルダーを取って入場してください。
※バッジ印刷済みの方は受付不要です。
※ホルダーは来場者と共通のものとなります。
※バッジは会期中11月28日・29日・30日にご使用いただきます。

事前に出展社バッジを印刷していないご出展社は、南1ホール出入口にあります「出展社カウンター」へお越しいただき、
出展社バッジの登録ならびに印刷を行ってからのご入場となります。
南1ホールの「出展社カウンター」は非常に混雑が予想されますため、事前に出展社バッジの登録ならびに印刷をして、
ご持参いただきますようお願いいたします。

----------------------------------------------------------------------
◆展示会に関するお問い合わせ先
展示会事務局
〒160-0004
東京都新宿区四谷3-2-1 フロントプレイス四谷ビル7階
TEL： 03-5363-1701　Email：office@tso-int.co.jp
営業時間：9:30〜18:30　※土日、祝祭日を除く
----------------------------------------------------------------
◆システムに関するお問い合わせ先
事前登録担当窓口　株式会社フリーダム・グループ
担当：佐藤
TEL:03-5733-4591（10:00 - 17:00 ※土日、祝祭日を除く）
E-mail：pregis.info@free-dom.net
----------------------------------------------------------------
※ ご質問に回答する際に個人を特定する情報をおうかがいすることが
ありますので、あらかじめご了承ください。`
  }
  return `本メールは下記のアドレス宛に送付されています。
${exhibitor.email}


${exhibitor.companyName || ''}
${exhibitor.familyName || ''}　${exhibitor.givenName || ''}　様

出展社バッジの申請について、お知らせいたします。
Freedom Group Demoでは、出展社バッジについても来場者バッジ同様、使用者の
情報を登録し、出展者ご自身で印刷していただく必要がございます。
下記の申請用ページにて、情報登録を行ってください。
なお、出展社バッジ申請用サイトへのアクセスには、ウェブサイト等で公開
する「出展者情報」の登録を行っていただいた「出展者情報入力ログインページ」
で使用しているIDとパスワードが必要になります。

----------------------------------------------------------------------
■会社名： ${exhibitor.companyName || ''}
■部署： ${exhibitor.department || ''}
■担当者名: ${exhibitor.familyName || ''}　${exhibitor.givenName || ''}　様
■ID : ${exhibitor.accountId}
■パスワード: ${exhibitor.password}
＜出展社バッジ申請用サイトログインページ＞
${url}/#/explain
→ID・パスワードを入力して、ログインしてください。
----------------------------------------------------------------------

～申請から発行までの流れ～
1.出展社バッジ申請用サイトにて必要な枚数分の使用者情報を登録
（1小間あたり6枚まで（2小間以降は1小間あたり4枚）申請可能、上限を超える
枚数が必要な場合には来場者バッジをご利用ください。）
2.申請した各使用者宛てにメールにて通知
3.使用者がご自身で出展社バッジを印刷
※申請期限はありません。会期中でも申請～発行まで可能です。

----------------------------------------------------------------------
【問い合わせ先】

 お問い合わせ先
 株式会社フリーダム・グループ®
 TEL 03-3433-5881  FAX 03-3433-1998
 E-Mail：pregis.info@free-dom.net
 URL:http://www.free-dom.net/`
}

export const makeRemindMailMessage = (exhibitor: ExhibitorModel): string => {
  return `本メールは下記のアドレス宛に送付されています。
${exhibitor.email}`
}

export const makeBadgeMailMessage = (badge: BadgeModel, exhibitorId: string): string => {
  return `本メールは下記のアドレス宛に送付されています。
${badge.email}

下記のURLよりバッジのPDFをダウンロードすることができます。印字の上ご持参ください。
${process.env.REACT_APP_FRONT_URL}/#/download/badges/${badge.id}?key=${exhibitorId}
`
}

export const formatDate = (date: string | Date): string => {
  date = new Date(date)
  if (!date.getFullYear()) return ''
  return `${date.getFullYear()}-${('0'+(date.getMonth()+1)).slice(-2)}-${('0'+date.getDate()).slice(-2)} ${('0'+date.getHours()).slice(-2)}:${('0'+date.getMinutes()).slice(-2)}`
}

export const createExhibitorsCSV = (exhibitors: ExhibitorModel[]) => {
  let CSV: string[][] = []
  // const keys = ['accountId', 'password', 'receptionId', 'boothsCount', 'country', 'familyName', 'familyNameEn', 'givenName', 'givenNameEn', 'companyName', 'companyNameEn', 'companyNameKana', 'department', 'departmentEn', 'position', 'positionEn', 'postalCode', 'prefecture', 'prefectureEn', 'municipality', 'municipalityEn', 'address', 'addressEn', 'email', 'tel']
  const keys = ['accountId', 'password', 'exhibition', 'composition', 'receptionId', 'country', 'familyName', 'givenName', 'companyName', 'companyNameKana', 'department', 'position', 'postalCode', 'prefecture', 'municipality', 'address', 'email', 'tel']
  const wordMap: {[key: string]: string} = {
    'accountId': 'アカウントID',
    'password': 'パスワード',
    'exhibition': '展示会',
    'composition': '構成展',
    'receptionId': '受付ID',
    'country': '国名',
    'familyName': '担当者姓',
    // 'familyNameEn': 'Family Name（アルファベット半角）',
    'givenName': '担当者名',
    // 'givenNameEn': 'Given Name（アルファベット半角）',
    'companyName': '会社名',
    // 'companyNameEn': '会社名（アルファベット半角）',
    'companyNameKana': '会社名（カタカナ）',
    'department': '所属部署',
    // 'departmentEn': '所属部署（アルファベット半角）',
    'position': '役職',
    // 'positionEn': '役職（アルファベット半角）',
    'postalCode': '郵便番号',
    'prefecture': '都道府県',
    // 'prefectureEn': '都道府県（アルファベット半角）',
    'municipality': '以下住所',
    // 'municipalityEn': '以下住所（アルファベット半角）',
    'address': 'ビル名・建物名など',
    // 'addressEn': 'ビル名・建物名など（アルファベット半角）',
    'email': 'E-Mail',
    'tel': '電話番号'
  }
  
  CSV.push(keys)
  CSV.push(keys.map(key => wordMap[key]).concat(['バッジ登録枚数']))
  exhibitors.forEach((exhibitor: any) => {
    CSV.push(keys.map(key => exhibitor[key]).concat([exhibitor.badges.length]))
  })
  return CSV
}

export const createBadgesCSV = (exhibitors: ExhibitorModel[]) => {
  let CSV: string[][] = []
  // const keys = ['barcodeId', 'displayName', 'displayNameEn', 'displayNameKana', 'companyName', 'companyNameEn', 'companyNameKana', 'department', 'departmentEn', 'position', 'positionEn', 'postalCode', 'prefecture', 'prefectureEn', 'municipality', 'municipalityEn', 'address', 'addressEn', 'email', 'tel']
  const keys = ['barcodeId', 'displayName', 'displayNameKana', 'companyName', 'companyNameKana', 'department', 'departmentEn', 'position', 'postalCode', 'prefecture', 'municipality', 'address', 'email', 'tel']

  const wordMap: {[key: string]: string} = {
    'barcodeId': 'バーコードID',
    'displayName': 'バッジ氏名',
    // 'displayNameEn': 'バッジ氏名（アルファベット半角）',
    'displayNameKana': 'バッジ氏名（カタカナ）',
    'companyName': '会社名',
    // 'companyNameEn': '会社名（アルファベット半角）',
    'companyNameKana': '会社名（カタカナ）',
    'department': '所属部署',
    'departmentEn': '所属部署（アルファベット半角）',
    'position': '役職',
    // 'positionEn': '役職（アルファベット半角）',
    'postalCode': '郵便番号',
    'prefecture': '都道府県',
    // 'prefectureEn': '都道府県（アルファベット半角）',
    'municipality': '以下住所',
    // 'municipalityEn': '以下住所（アルファベット半角）',
    'address': 'ビル名・建物名など',
    // 'addressEn': 'ビル名・建物名など（アルファベット半角）',
    'email': 'E-Mail',
    'tel': '電話番号'
  }
  CSV.push(['accountId'].concat(keys.map(key => wordMap[key])))
  exhibitors.forEach((exhibitor: any) => {
    exhibitor.badges.forEach((badge: any) => {
      CSV.push([exhibitor.accountId].concat(keys.map(key => badge[key])))
    })
  })
  return CSV
}

export const getAuthQueries = (search: string) => {
  const queryParams = queryString.parse(search);
  let token, key
  if (queryParams.token instanceof Array) {
    token = queryParams.token[0]
  } else {
    token = queryParams.token as string | undefined
  }
  if (queryParams.key instanceof Array) {
    key = queryParams.key[0]
  } else {
    key = queryParams.key as string | undefined
  }

  return [token, key]
}

export const getHostExhibition = () => {
  let exhibition = 'FGDEMO'
  if (window.location.host.includes('sportec')) {
    exhibition = 'SPORTEC2023'
  }
  if (window.location.host.includes('caferes')) {
    exhibition = 'CAFERES2023'
  }
  if (window.location.host.includes('iloj')) {
    exhibition = 'ILOJ2023'
  }
  if (window.location.host.includes('wellness')) {
    exhibition = 'WELLNESS2023'
  }
  return exhibition
}